import { Badge } from "../ui/badge";
import type { TicketPriority, TicketStatus } from "../../services/ticketsService";

const PRIORITY_LABELS: Record<TicketPriority, string> = {
  baja: "Baja",
  media: "Media",
  alta: "Alta",
  critica: "Crítica",
};

const PRIORITY_CLASSES: Record<TicketPriority, string> = {
  baja: "bg-secondary text-secondary-foreground border-transparent",
  media: "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  alta: "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900",
  critica: "bg-destructive text-white border-transparent",
};

const STATUS_LABELS: Record<TicketStatus, string> = {
  abierto: "Abierto",
  en_progreso: "En progreso",
  en_revision: "En revisión",
  resuelto: "Resuelto",
  cerrado: "Cerrado",
  reabierto: "Reabierto",
  no_se_va_a_arreglar: "No se va a arreglar",
};

const STATUS_CLASSES: Record<TicketStatus, string> = {
  abierto: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  en_progreso: "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  en_revision: "bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900",
  resuelto: "bg-green-100 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  cerrado: "bg-secondary text-secondary-foreground border-transparent",
  reabierto: "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900",
  no_se_va_a_arreglar: "bg-muted text-muted-foreground border-transparent",
};

export const PRIORITY_OPTIONS: TicketPriority[] = ["baja", "media", "alta", "critica"];
export const STATUS_ORDER: TicketStatus[] = [
  "abierto",
  "en_progreso",
  "en_revision",
  "resuelto",
  "cerrado",
  "reabierto",
  "no_se_va_a_arreglar",
];
export { STATUS_LABELS, PRIORITY_LABELS };

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  return <Badge className={PRIORITY_CLASSES[priority]}>{PRIORITY_LABELS[priority]}</Badge>;
}

export function StatusBadge({ status }: { status: TicketStatus }) {
  return <Badge className={STATUS_CLASSES[status]}>{STATUS_LABELS[status]}</Badge>;
}
